import Dexie from 'dexie';

export const db = new Dexie('myDatabase');
db.version(1).stores({
  uploads: '++id, name, upload', // Primary key and indexed props
});
